import {
  ByLocationCard,
  ByLocationCardVariantEnum,
} from '@app/feature/statistics/components/by-location-card/by-location.card';
import { useCpmsBoGetEnergyDeliveredByLocationQuery } from '@service/cpms-bo-transaction-reports-energy-statistics.service';

import { useFilters } from '../../context/filters.context';

export const EnergyByLocationCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();

  const { data } = useCpmsBoGetEnergyDeliveredByLocationQuery({
    ...transformedFilters,
  });

  return (
    <ByLocationCard data={data} variant={ByLocationCardVariantEnum.Energy} />
  );
};
